<template>
  <div class="table-wrapper">
    <div :class="['table-wrapper-inner', { 'hide-selection': !multiSelectMode}]">
      <el-row class="table-top-panel">
        <el-col class="counter">
          件数：{{counter}}件
        </el-col>
        <el-col class="other-command">
          <slot name="other-command" />
        </el-col>
        <!-- <template v-if="!addRowMode"> -->
      </el-row>
      <el-row class="plus-button">
        <template v-if="addRowMode">
          <el-col class="add-row">
            <!-- <el-button  @click="clickAddRow">+</el-button> -->
            <el-button type="info" @click="clickAddRow" circle icon="el-icon-plus"></el-button>
          </el-col>
        </template>
      </el-row>
      <el-table
        ref="table"
        :data="tableData"
        :highlight-current-row="true"
        :default-sort="defaultSort"
        :table-header-name="tableHeaderName"
      >
        <slot name="columns" />
      </el-table>
    </div>
  </div>
</template>

<script>

export default {
  components: {
  },
  props: {
    tableData: {
      type: Array,
      default: () => ([])
    },
    tableDataName: {
      type: String,
      default: ''
    },
    multiSelect: {
      type: Boolean,
      default: true
    },
    defaultSort: Object,
    selectable: {
      type: Function,
      default: () => true
    },
    tableHeaderName: {
      type: Array,
      default: () => ([])
    },
    addRowMode: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    counter: {
      get () {
        return this.tableData.length.toLocaleString()
      }
    },
    disabledMultipleDelete: {
      get () {
        return this.$refs.table.selection.length === 0
      }
    }
  },
  mounted () {
    const el = this.$el
    const tableHeader = el.querySelector('.el-table__header-wrapper')
    // const tableTopPanel = el.querySelector('.table-top-panel')
    this.$nextTick(() => {
      // const tableHeaderRect = tableHeader.getBoundingClientRect()
      // const tableTopPanelRect = tableTopPanel.getBoundingClientRect()
      // tableTopPanel.style.top = tableTopPanelRect.top + 'px'
      // tableHeader.style.top = tableHeaderRect.top + 'px'
      const blankCol = tableHeader.querySelector('th.blank')
      if (blankCol) {
        el.style.setProperty('--table-width', '100%')
      }
    })
  },
  methods: {
    clickAddRow () {
      var data = this.tableData
      this.$emit('add-row', this.tableDataName, data)
    }
  },
  data () {
    return {
      multiSelectMode: false
    }
  }
}
</script>

<style lang="scss" scoped>
.table-wrapper {
  --table-width: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  ::v-deep.table-wrapper-inner {
    width: 100%;
    &.hide-selection {
      .el-table {
        .col-selection {
          visibility: hidden;
        }
      }
    }
    .table-top-panel {
      display: flex;
      justify-content: flex-end;
      align-items: flex-end;
      background-color: var(--background-color);
      position: sticky;
      z-index: 200;
      .el-col {
        width: auto;
        margin-left: 1em;
        height: 2em;
        display: flex;
        justify-content: center;
        align-items: center;
        &.multi-select {
          width: 8em;
          padding-right: 4em;
        }
        &.cancel {
          flex-grow: 0;
          width: 8em;
        }
        .el-icon-delete {
          margin-left: 1em;
          &::before {
            font-size: 1.5em;
          }
        }
      }
      .counter {
        color: blue;
      }
      .counter,
      .csv-export,
      .multi-select,
      .cancel {
        flex-grow: 0;
      }
      .other-command {
        flex-grow: 2;
      }
    }
    .plus-button {
      text-align:right;
      .el-col {
        height: 3em;
      }
    }
    .el-table {
      width: auto !important;
      background-color: var(--background-color);
      &:before {
        background-color: transparent;
      }
      col {
        width: auto !important;
      }
      .col-blank {
        visibility: hidden;
      }
      .el-table__header-wrapper {
        position: sticky;
        z-index: 200;
        display: inline-block;
        .el-table__empty-block {
          width: 100% !important;
        }
      }
      .el-table__body-wrapper {
        .el-table__empty-block {
          width: 100% !important;
        }
      }
      .cell {
        height: 55px;
      }
      table {
        width: var(--table-width) !important;
      }
      tbody {
        color: black;
      }
      th,
      td {
        background-color: var(--background-color);
        padding-bottom: 3px;
      }
      &.el-table--enable-row-hover .el-table__body tr:hover > td {
        background-color: #F5F7FA
      }
      .col-selection {
        width: 2.6em;
        .el-checkbox {
          &.is-disabled {
            visibility: hidden;
          }
          .el-checkbox__input {
            .el-checkbox__inner {
              width: 1.1em;
              height: 1.1em;
              border-radius: 25%;
              border-width: 0.1em;
              border-color: var(--primary-color);
              &:after {
                border-width: 0.1em;
                height: 0.45em;
                width: 0.2em;
                top: 0.1em;
                left: 0.25em;
              }
            }
            &.is-checked,
            &.is-indeterminate {
              .el-checkbox__inner {
                background-color: var(--primary-color);
              }
            }
            &.is-indeterminate {
              .el-checkbox__inner:before {
                height: 0.2em;
                top: 0.3em;
              }
            }
          }
        }
      }
    }
  }
}
</style>
